<template>
  <Popover :popover="groupsPopoverRef">
    <template #content>
      <PopoverRow
        v-for="group in groupsRef"
        :key="group.id"
        :is-active="selectedGroupIdRef === group.id"
        @emit:click="(e) => handleSwitchGroup(e, group.id)"
      >
        <template #content>
          <CheckFullIcon color="primary" :is-checked="selectedGroupIdRef === group.id" />
          <div class="group-info">
            <!-- <NotificationsBadge
              :numberOfNotifications="
                allNotificationsPerGroupRef?.find((notifPerGroup) => notifPerGroup.mentorshipGroupId === group.id)
                  ?.notifications.total
              "
            /> -->
            <p>{{ group?.name }}</p>
            <div class="users-list" v-if="group.users.length">
              <UserBadge :user="group.users.find(getMentor)" noStatus variant="small" />
              <UsersBadgesStack :users="group.users.filter(getMentees)" noStatus variant="small" />
            </div>
          </div>
          <div v-if="groupRolesRef?.includes(RoleEnumTypeV2.MENTOR)" class="group-more-actions">
            <MoreOptionsIcon color="black" />
          </div>
        </template>
      </PopoverRow>
    </template>
  </Popover>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { RoleEnumTypeV2 } from '@/features/auth/types'
import useGroups from '@/features/groups/hooks/use-groups.hook'
import { selectGetSelectedGroupId } from '@/features/groups/stores/groups/groups.selectors'
import groupsStore from '@/features/groups/stores/groups/groups.store'
import { getMentees, getMentor } from '@/features/groups/utils'
import UserBadge from '@/features/sessions/components/user-badge/user-badge.vue'
import UsersBadgesStack from '@/features/sessions/components/users-badges-stack/users-badges-stack.vue'
import CheckFullIcon from '@/features/ui/components/icons/check-full-icon.vue'
import MoreOptionsIcon from '@/features/ui/components/icons/more-options-icon.vue'
import Popover from '@/features/ui/components/popover/popover.vue'
import PopoverRow from '@/features/ui/components/popover/popover-row/popover-row.vue'
import type { GroupSettingsModalType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { selectGetGroupsPopover } from '@/features/ui/store/popover/popover.selectors'
import popoversStore from '@/features/ui/store/popover/popover.store'
import useGroupRoles from '@/features/users/hooks/use-group-roles.hook'

const groupsPopoverRef = selectGetGroupsPopover(popoversStore)

const perPageRef = ref<number>(1000)
const { groupsRef } = useGroups({ perPageRef })
const selectedGroupIdRef = selectGetSelectedGroupId(groupsStore)
const { groupRolesRef } = useGroupRoles()

function openGroupSettings(groupId: string) {
  console.log('openGroupSettings', groupId)
  modalsStore.toggleModal('group-settings', true)
  modalsStore.updateModalAttachedData<GroupSettingsModalType>('group-settings', { groupId })
}

const handleSwitchGroup = (e: MouseEvent, newGroupId: string) => {
  // otherwise, we select the new mentorship group
  const newSelectedGroup = groupsRef.value.find((group) => group.id === newGroupId)
  // select the new mentorship group
  if (newSelectedGroup) {
    groupsStore.setSelectedGroupId(newSelectedGroup.id)
  }

  popoversStore.togglePopover('groups', false)

  if ((e.target as HTMLElement).closest('.group-more-actions')) {
    openGroupSettings(newGroupId)
  }
}
</script>

<style lang="scss">
@import './groups-popover.scss';
</style>
